import React from "react";
import NewUiHeader from "../NewUIHeader/NewUIHeader";
import NewFooterUI from "../NewFooterUI/NewFooterUI";
import styles from "./Blogs.module.scss";
import singleBlogImg from "../../../assets/new-images/single-blog-1.png";
import mallRoad from "../../../assets/new-images/mall-road.png";
import church from "../../../assets/new-images/christ-church.png";
import jakhoo from "../../../assets/new-images/jakhoo-temple.png";
import kufri from "../../../assets/new-images/kufri.png";
import { Link } from "react-router-dom";
import miniBlogImg from "../../../assets/new-images/blog-3.jpg";

const SingleBlogPage = () => {
  const blogsData = [
    {
      image: miniBlogImg,
      title: "  Lorem ipsum dolor sit amet consectetur Nisl rutrum leo...",
    },
    {
      image: miniBlogImg,
      title: "  Lorem ipsum dolor sit amet consectetur Nisl rutrum leo...",
    },
    {
      image: miniBlogImg,
      title: "  Lorem ipsum dolor sit amet consectetur Nisl rutrum leo...",
    },
    {
      image: miniBlogImg,
      title: "  Lorem ipsum dolor sit amet consectetur Nisl rutrum leo...",
    },
  ];

  return (
    <div className={styles.single_blog}>
      <NewUiHeader />
      <section className="common_padding">
        <div className="container">
          <div className={styles.single_flex_data}>
            <div className={styles.left_side_data}>
              {" "}
              <span>Adventure & Activities</span>
              <h3>
                Lorem ipsum dolor sit amet consectetur Nisl rutrum leo mauris
                tristique.
              </h3>
              <small>26 March 2025</small>
              <p className="mt-20">
                Shimla – “Queen of Hills,” is one of the most beloved hill
                stations in Himachal Pradesh, attracting visitors from all over
                India and beyond. It is known for its pleasant weather, colonial
                architecture, and breathtaking landscapes, Shimla holds a
                special place in every traveler’s heart. However, for many
                tourists, the excitement of visiting Shimla is dampened by
                getting stuck in the city’s infamous traffic jams. Long vehicle
                queues can steal precious time and leave visitors with only a
                glimpse of the beauty this enchanting hill station offers.
              </p>
              <p>
                But don’t let the thought of traffic dishearten you! Shimla is
                full of gems waiting to be explored, and with proper planning,
                you can make the most of your trip. To help you enjoy your
                journey without missing out on the best spots, we’ve created
                this guide to the top places to visit in Shimla. Follow this
                plan to bypass the usual pitfalls, avoid unnecessary delays, and
                immerse yourself in the true charm of this hill paradise.
              </p>
              <div className={styles.single_blog_data}>
                <h4>1. The Ridge</h4>
                <div className={styles.blog_img}>
                  <img src={singleBlogImg} alt="siingle blog image" />
                </div>
                <p>
                  The Ridge is the heart of Shimla and a bustling open space
                  surrounded by colonial buildings, cafes, and shops. It offers
                  beautiful panoramic views of the snow-clad Himalayas, it’s a
                  favorite spot for tourists and locals alike. The Ridge is
                  where most cultural events, fairs, and festivals take place.
                  From here, you can also marvel at the beauty of landmarks like
                  Christ Church and Mall Road.
                </p>
                <h4>2. Mall Road</h4>
                <div className={styles.blog_img}>
                  <img src={mallRoad} alt="siingle blog image" />
                </div>
                <p>
                  Mall Road is the bustling commercial hub of Shimla. Lined with
                  charming cafes, boutique shops, and souvenir stores, it’s the
                  perfect place to experience the lively spirit of the town. The
                  no-vehicle policy here ensures a peaceful stroll while
                  enjoying the fresh mountain air. Visit in the evening when the
                  street lights up with activity and street vendors set up shop,
                  adding a touch of festivity to the ambiance.
                </p>
                <h4>3. Christ Church</h4>
                <div className={styles.blog_img}>
                  <img src={church} alt="siingle blog image" />
                </div>
                <p>
                  Christ Church was built in 1857 and it is one of the most
                  iconic landmarks of Shimla. This neo-Gothic masterpiece stands
                  as a reminder of the city’s colonial past. The church’s large
                  stained-glass windows, intricately designed interiors, and
                  peaceful ambiance make it a favorite spot for visitors.
                </p>
                <h4>4. Jakhoo Temple</h4>
                <div className={styles.blog_img}>
                  <img src={jakhoo} alt="siingle blog image" />
                </div>
                <p>
                  Jakhoo Temple, dedicated to Lord Hanuman, is perched on Jakhoo
                  Hill, the highest peak in Shimla. The temple is known for its
                  108-feet tall Hanuman statue that towers over the surrounding
                  forests. The statue is visible from almost any part of Shimla.
                  Legends say Lord Hanuman rested here during his journey to
                  find the Sanjeevani herb, adding a mythical charm to the
                  temple.
                </p>
                <h4>4. Kufri</h4>
                <div className={styles.blog_img}>
                  <img src={kufri} alt="siingle blog image" />
                </div>
                <p>
                  Kufri is a small yet beautiful hill station near Shimla. It is
                  known for its adventure activities and stunning landscapes,
                  it’s a haven for nature lovers and thrill-seekers. Kufri
                  transforms into a snowy wonderland during winter, making it a
                  popular destination for skiing and snowboarding. In summer,
                  its lush green meadows and clear skies are perfect for picnics
                  and hikes.
                </p>
                <h4>Conclusion</h4>
                <p>
                  Shimla is more than just a hill station; it’s an experience
                  that stays with you forever. From its scenic beauty to its
                  colonial charm, every corner of Shimla tells a story. To make
                  your trip truly unforgettable, consider staying at properties
                  managed by Eco Hospitalities.{" "}
                  <Link to="">Hotel Woodrina by Eco Hospitalities,</Link>  
                  situated among lush pine forests, offers a cozy and serene
                  retreat. Meanwhile, {" "}
                  <Link to="">Golden Fern Resort by Eco Hospitalities  </Link>{" "}
                  is perfect for those looking for luxury and breathtaking
                  views. Both properties are conveniently located, ensuring you
                  can explore Shimla’s best attractions with ease. So, pack your
                  bags, plan your itinerary, and get ready to explore the
                  best places to visit in Shimla for a memorable adventure!{" "}
                  <br />
                  Suggested Reading:
                  <Link to="">
                    {" "}
                    Shimla’s Transition from Old Shimla to New Shimla
                  </Link>
                </p>
              </div>
            </div>
            <div className={styles.aside_blog}>
              <h4 className="px_15 ">must reads</h4>
              {blogsData?.map((item, i) => (
                <div className="flex flex_gap_10 px_15 " key={i}>
                  <div className={styles.mini_img}>
                    <img src={item?.image} alt="blog image" />
                  </div>
                  <div>
                    <h5>{item.title}</h5>
                    <span>Adventure & Activities</span>
                  </div>
                </div>
              ))}
              <div className="mt-10 pt_10 border_top px_15 ">
                <h4>SHARE THE ARTICAL</h4>
                <div className="flex align_items_center flex_gap_5 mt-10">
                  <Link to="">
                    <svg
                      width="25"
                      height="25"
                      viewBox="0 0 25 25"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle cx="12.5" cy="12.5" r="12" stroke="#333333" />
                      <path
                        d="M13.75 13.4375H15.3125L15.9375 10.9375H13.75V9.6875C13.75 9.04375 13.75 8.4375 15 8.4375H15.9375V6.3375C15.7337 6.31063 14.9644 6.25 14.1519 6.25C12.455 6.25 11.25 7.28562 11.25 9.1875V10.9375H9.375V13.4375H11.25V18.75H13.75V13.4375Z"
                        fill="#333333"
                      />
                    </svg>
                  </Link>
                  <Link to="">
                    <svg
                      width="25"
                      height="25"
                      viewBox="0 0 25 25"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle cx="12.5" cy="12.5" r="12" stroke="#333333" />
                      <path
                        d="M16.9062 8.06878C16.3332 7.4901 15.6506 7.03126 14.8984 6.71901C14.1462 6.40676 13.3394 6.24734 12.525 6.25003C9.1125 6.25003 6.33125 9.03128 6.33125 12.4438C6.33125 13.5375 6.61875 14.6 7.15625 15.5375L6.28125 18.75L9.5625 17.8875C10.4688 18.3813 11.4875 18.6438 12.525 18.6438C15.9375 18.6438 18.7188 15.8625 18.7188 12.45C18.7188 10.7938 18.075 9.23753 16.9062 8.06878ZM12.525 17.5938C11.6 17.5938 10.6937 17.3438 9.9 16.875L9.7125 16.7625L7.7625 17.275L8.28125 15.375L8.15625 15.1813C7.64222 14.3607 7.36933 13.4121 7.36875 12.4438C7.36875 9.60628 9.68125 7.29378 12.5187 7.29378C13.8937 7.29378 15.1875 7.83128 16.1562 8.80628C16.636 9.2837 17.0162 9.85162 17.2748 10.4771C17.5333 11.1026 17.6651 11.7732 17.6625 12.45C17.675 15.2875 15.3625 17.5938 12.525 17.5938ZM15.35 13.7438C15.1937 13.6688 14.4312 13.2938 14.2937 13.2375C14.15 13.1875 14.05 13.1625 13.9438 13.3125C13.8375 13.4688 13.5437 13.8188 13.4562 13.9188C13.3687 14.025 13.275 14.0375 13.1187 13.9563C12.9625 13.8813 12.4625 13.7125 11.875 13.1875C11.4125 12.775 11.1062 12.2688 11.0125 12.1125C10.925 11.9563 11 11.875 11.0812 11.7938C11.15 11.725 11.2375 11.6125 11.3125 11.525C11.3875 11.4375 11.4188 11.3688 11.4688 11.2688C11.5188 11.1625 11.4937 11.075 11.4562 11C11.4187 10.925 11.1062 10.1625 10.9812 9.85003C10.8562 9.55003 10.725 9.58753 10.6312 9.58128H10.3312C10.225 9.58128 10.0625 9.61878 9.91875 9.77503C9.78125 9.93128 9.38125 10.3063 9.38125 11.0688C9.38125 11.8313 9.9375 12.5688 10.0125 12.6688C10.0875 12.775 11.1062 14.3375 12.6562 15.0063C13.025 15.1688 13.3125 15.2625 13.5375 15.3313C13.9062 15.45 14.2438 15.4313 14.5125 15.3938C14.8125 15.35 15.4312 15.0188 15.5562 14.6563C15.6875 14.2938 15.6875 13.9875 15.6438 13.9188C15.6 13.85 15.5062 13.8188 15.35 13.7438Z"
                        fill="black"
                      />
                    </svg>
                  </Link>
                  <Link to="">
                    <svg
                      width="25"
                      height="25"
                      viewBox="0 0 25 25"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle cx="12.5" cy="12.5" r="12" stroke="#333333" />
                      <g clip-path="url(#clip0_6868_18005)">
                        <mask
                          id="mask0_6868_18005"
                          style={{maskType:"luminance"}}
                          maskUnits="userSpaceOnUse"
                          x="7"
                          y="7"
                          width="12"
                          height="12"
                        >
                          <path d="M7 7H19V19H7V7Z" fill="white" />
                        </mask>
                        <g mask="url(#mask0_6868_18005)">
                          <path
                            d="M16.45 7.56226H18.2903L14.2703 12.1685L19 18.4377H15.2971L12.3949 14.6363L9.07771 18.4377H7.23571L11.5351 13.5091L7 7.56311H10.7971L13.4166 11.0371L16.45 7.56226ZM15.8029 17.3337H16.8229L10.24 8.60883H9.14629L15.8029 17.3337Z"
                            fill="#333333"
                          />
                        </g>
                      </g>
                      <defs>
                        <clipPath id="clip0_6868_18005">
                          <rect
                            width="12"
                            height="12"
                            fill="white"
                            transform="translate(7 7)"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <NewFooterUI />
    </div>
  );
};

export default SingleBlogPage;
